/* eslint-disable indent */
import { Controller, useFormContext } from "react-hook-form"
import { useDispatch, useSelector } from "react-redux"
import Dropdown from "src/shared/components/forms/selelct-dropdown/Dropdown"
import InputTextSuggestions, {
    InputTextSuggestion,
} from "src/shared/components/forms/input-text-suggestions/InputTextSuggestions"
import ModalMixto from "src/shared/sections/payment/mixto/ModalMixto"
import { PAYMENT_METHODS, PAYMENT_TYPES } from "src/constants/payments"
import { RoleNames } from "src/shared/hooks/useAuth"
import { useProfile } from "src/shared/hooks/useProfile"
import { useModulos } from "src/shared/hooks/useModulos"
import accountBoxFill from "src/shared/icons/accountBoxFill"
import { RootState } from "src/store/store"
import { toggleModalPagoMixtoEdited, toggleModalPagoMixtoOpen } from "src/store/ventaHabitacion/ventaHabitacionSlice"
import { LovePoint } from "src/pages/easyrewards/components/InputAbonarEasyRewards/InputAbonarEasyRewards.types"
import { AbonarEasyRewardsField } from "src/pages/easyrewards/components/AbonarEasyRewardsField/AbonarEasyRewardsField"
import { CardNumber } from "src/pages/room-service/detalle-compra/sections/Fields"
import FormSection from "../../components/FormSection/FormSection"
import FormSectionRow from "../../components/FormSectionRow/FormSectionRow"
import { CardNumberField } from "../../components/CardNumberField/CardNumberField"
import { PaymentMethodField, PaymentTypeField } from "../FieldsValetParking"
import usePaymentOptions from "../../VentaHabitacion.constants"
import { DefaultValuesType } from "../../VentaHabitacion.types"

interface PagoProps {
    lovePointsAmount: LovePoint | null
    setLovePointsAmount: (value: LovePoint | null) => void
    onLovePointsChange: (value: any) => void
    colaboradoresSuggestions: InputTextSuggestion[]
    mostrarErrorLovePoints: (mensaje: string) => void
    onConsultarSaldo: () => void
}

// Método de pago de la venta (valet o recepción), pago mixto y easyrewards
const Pago = ({
    lovePointsAmount,
    setLovePointsAmount,
    onLovePointsChange,
    colaboradoresSuggestions,
    mostrarErrorLovePoints,
    onConsultarSaldo,
}: PagoProps) => {
    const { control, getValues, setValue } = useFormContext<DefaultValuesType>()
    const dispatch = useDispatch()
    const { rolName } = useProfile()
    const { easyRewards: withEasyrewards } = useModulos()
    const { isModalPagoMixtoEdited, isModalPagoMixtoOpen } = useSelector((root: RootState) => root.ventaHabitacion)

    return (
        <FormSection title="Pago" style={{ marginBottom: 0 }}>
            <FormSectionRow>
                {rolName === RoleNames.valet && (
                    <div className="venta-habitacion__inputs" style={{ margin: 0, marginTop: "16px" }}>
                        <PaymentTypeField
                            setLovePointsAmount={setLovePointsAmount}
                            lovePointsAmount={lovePointsAmount}
                        />
                        <PaymentMethodField
                            setLovePointsAmount={setLovePointsAmount}
                            lovePointsAmount={lovePointsAmount}
                        />
                        <CardNumber />
                    </div>
                )}
                {rolName !== RoleNames.valet && (
                    <>
                        <Controller
                            control={control}
                            name={"method"}
                            rules={{ required: true }}
                            render={({ field: { value, onChange }, formState: { errors } }) => (
                                <div className="payment-method-field__wrapper">
                                    <div className="venta-habitacion-input">
                                        <Dropdown
                                            placement={"top"}
                                            icon={"creditCard"}
                                            iconInOptions={false}
                                            errorHintText={errors?.method ? "Selecciona una opción" : ""}
                                            label={"Método de pago"}
                                            placeholder={"Selecciona una opción"}
                                            options={[...usePaymentOptions()]}
                                            value={value || PAYMENT_METHODS.efectivo.value}
                                            onClick={({ value }) => {
                                                onChange(value)
                                                if (value === PAYMENT_TYPES.mixto) {
                                                    dispatch(toggleModalPagoMixtoOpen(true))
                                                } else {
                                                    const costs = getValues("costs")
                                                    setValue("extra", [
                                                        {
                                                            amount: costs?.general,
                                                            type: value,
                                                            number: "",
                                                            easyrewards_id: lovePointsAmount?.id,
                                                        },
                                                    ])
                                                    setValue("costs", {
                                                        ...costs,
                                                        total: 0,
                                                    })
                                                }
                                            }}
                                        />
                                    </div>

                                    {!isModalPagoMixtoOpen && value === "mixto" ? (
                                        <span
                                            className="payment-method-field__link"
                                            style={{ marginTop: 32 }}
                                            onClick={() => {
                                                dispatch(toggleModalPagoMixtoOpen(true))
                                                dispatch(toggleModalPagoMixtoEdited(true))
                                            }}
                                        >
                                            {"Editar"}
                                        </span>
                                    ) : null}
                                </div>
                            )}
                        />

                        <ModalMixto
                            paymentOptions={[
                                PAYMENT_METHODS.efectivo,
                                PAYMENT_METHODS.visaOMasterCard,
                                PAYMENT_METHODS.amex,
                                PAYMENT_METHODS.depositoOTransferencia,
                                PAYMENT_METHODS.cortesia,
                                PAYMENT_METHODS.consumoInterno,
                            ]}
                            visible={isModalPagoMixtoOpen}
                            edited={isModalPagoMixtoEdited}
                            onLovePointsChange={onLovePointsChange}
                            onClose={() => {
                                dispatch(toggleModalPagoMixtoOpen(false))
                                dispatch(toggleModalPagoMixtoEdited(false))
                            }}
                        />
                        <div className="payment-method-fields">
                            {(getValues("method") === PAYMENT_METHODS.visaOMasterCard.value ||
                                getValues("method") === PAYMENT_METHODS.amex.value ||
                                getValues("method") === PAYMENT_METHODS.depositoOTransferencia.value) && (
                                <>
                                    <div>
                                        <CardNumberField setLovePointsAmount={setLovePointsAmount} />
                                    </div>
                                    <div className="easyrewards-abonar__input-text">
                                        <AbonarEasyRewardsField
                                            setLovePointsAmount={setLovePointsAmount}
                                            lovePointsAmount={lovePointsAmount}
                                        />
                                    </div>
                                </>
                            )}

                            {getValues("method") === PAYMENT_METHODS.mixto.value && (
                                <div className="easyrewards-abonar__input-text">
                                    <AbonarEasyRewardsField
                                        setLovePointsAmount={
                                            getValues("method") === PAYMENT_TYPES.LovePoints
                                                ? onLovePointsChange
                                                : setLovePointsAmount
                                        }
                                        lovePointsAmount={lovePointsAmount}
                                    />
                                </div>
                            )}

                            {getValues("method") === PAYMENT_METHODS.efectivo.value && (
                                <div className="easyrewards-abonar__input-text">
                                    <AbonarEasyRewardsField
                                        setLovePointsAmount={setLovePointsAmount}
                                        lovePointsAmount={lovePointsAmount}
                                    />
                                </div>
                            )}
                            {getValues("method") === PAYMENT_METHODS.consumoInterno.value && (
                                <div className="easyrewards-abonar__input-text">
                                    <Controller
                                        control={control}
                                        name="colaboradorConsumoInterno"
                                        rules={{
                                            required: true,
                                            validate: (v) => !!v?.id && !!v?.title,
                                        }}
                                        render={({ field: { value, onChange }, fieldState: { error } }) => (
                                            <InputTextSuggestions
                                                suggestionsListWidth="255px"
                                                suggestions={colaboradoresSuggestions}
                                                value={value || ""}
                                                inputTextConfig={{
                                                    label: "Nombre del personal",
                                                    placeholder: "Nombre del personal",
                                                    type: "text",
                                                    icon: accountBoxFill,
                                                    error: !!error,
                                                    errorhinttext:
                                                        error?.type === "validate" || error?.type === "required"
                                                            ? "Escribe el nombre del responsable"
                                                            : "",
                                                }}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </div>
                            )}
                            {getValues("method") === PAYMENT_METHODS.lovePoints.value && (
                                <>
                                    <CardNumberField setLovePointsAmount={setLovePointsAmount} />
                                    {withEasyrewards && (
                                        <div className="venta-habitacion__consultar-saldo">
                                            <span
                                                className="venta-habitacion__consultar-saldo__link"
                                                onClick={() => {
                                                    const numero = getValues("extra.0.number")?.trim()
                                                    if (!numero) return

                                                    if (!lovePointsAmount?.id) {
                                                        return
                                                    } else if (lovePointsAmount?.saldo === 0) {
                                                        mostrarErrorLovePoints(
                                                            "Tu saldo actual de Love Points es insuficiente. Actualmente tienes <strong>0 puntos</strong> disponibles. Intenta con otro método de pago."
                                                        )
                                                        return
                                                    } else {
                                                        onConsultarSaldo()
                                                    }
                                                }}
                                                style={{
                                                    cursor: getValues("extra.0.number")?.trim()
                                                        ? "pointer"
                                                        : "not-allowed",
                                                    opacity: getValues("extra.0.number")?.trim() ? 1 : 0.5,
                                                }}
                                            >
                                                Consultar saldo
                                            </span>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </>
                )}
            </FormSectionRow>
        </FormSection>
    )
}

export default Pago
